export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const GET_DOCUMENT_TOKEN = 'GET_DOCUMENT_TOKEN';
export const GET_OFFLINE_DOCUMENT_TOKEN = 'GET_OFFLINE_DOCUMENT_TOKEN';
export const DELETE_DOCUMENT_TOKEN = 'DELETE_DOCUMENT_TOKEN';
export const GET_COMPANIES = 'GET_COMPANIES';
export const GET_GROUPS = 'GET_GROUPS';
export const RESPONSE_ATTENDANCE = 'RESPONSE_ATTENDANCE';
export const RESPONSE_MEETING_AUTHORISATION = 'RESPONSE_MEETING_AUTHORISATION';
export const RESPONSE_VOTING_AUTHORISATION = 'RESPONSE_VOTING_AUTHORISATION';
export const CAST_VOTE = 'CAST_VOTE';
export const REQUEST_FORGOTTEN = 'REQUEST_FORGOTTEN';
export const GET_PROFILE = 'GET_PROFILE';
export const PUT_PROFILE = 'PUT_PROFILE';
export const GET_AVATAR = 'GET_AVATAR';
export const GET_CAPTCHA = 'GET_CAPTCHA';
export const PUT_AVATAR = 'PUT_AVATAR';
export const LIST_MEETINGS = 'GET_MEETINGS';
export const LIST_GROUP_MEETINGS = 'LIST_GROUP_MEETINGS';
export const LIST_AGENDA = 'LIST_AGENDA';
export const GET_VOTE = 'GET_VOTE';
export const GET_WAR = 'GET_WAR';
export const GET_DOC = 'GET_DOC';
export const SET_NOTES = 'SET_NOTES';
export const GET_NOTES = 'GET_NOTES';
export const LOG_ERROR = 'LOG_ERROR';
export const DOC_READ = 'DOC_READ';
export const DOC_SHARING = 'DOC_SHARING';
export const GET_PING = 'GET_PING';
export const DOC_NATIVE = '"DOC_NATIVE'

export const BT_FROM_EMAIL_ADDRESS = 'password@boardtrac.com.au';
export const EDIT_TASK_STATUS ='EDIT_TASK_STATUS';
export const GET_COMPANY_TASKS = 'GET_COMPANY_TASKS';
export const GET_COMPANY_TASKS_USERS = 'GET_COMPANY_TASKS_USERS';
export const GET_COMPANY_TASKS_CATEGORIES = 'GET_COMPANY_TASKS_CATEGORIES';

// Ruslan 1/09/2017 start
export const DEFAULT_COMPANY_COLOR = 'rgb(79, 80, 86)';
export const COMPANY_COLOR_VAR = '--company-color';
export const GROUP_HOVER_COLOR_VAR = '--group-hover-color';
export const GROUP_COLOR_VAR = '--group-color';

export const SORT_LAST_MODIFIED = 'Last Modified';
export const SORT_AZ = 'A-Z';
export const SORT_ZA = 'Z-A';
// Ruslan 1/09/2017 finish

export const PAIR_COMPANY = 'PAIR_COMPANY';
export const REQUEST_ISUSERNAMEUNIQUE = 'REQUEST_ISUSERNAMEUNIQUE';
export const REQUEST_VERIFYUSERPORTALTOKEN = 'REQUEST_VERIFYUSERPORTALTOKEN';
export const REQUEST_REGISTER = 'REQUEST_REGISTER';
export const REQUEST_VERIFYUSERPORTALPASSWORDTOKEN = 'REQUEST_VERIFYUSERPORTALPASSWORDTOKEN';
export const REQUEST_RESET_PASSWORD = 'REQUEST_RESET_PASSWORD';
export const REQUEST_LOCAL_HOST = 'REQUEST_LOCAL_HOST';

// Meetings
export const MTG_UPCOMING = 'upcoming';
export const MTG_PREVIOUS = 'previous';
export const MTG_DRAFT = 'draft';

export const MTG_MAP_BING_KEY =
    'TzAmMOUrdbBuBAHSvHMO~EUSLW0jLTmPUuUWNmlRYmA~ApV_s1lGNQ2j9_TtcRVJRNWlmLAqEkoguB6Z3i-Gs21TQN2Dv42hprM_hysyGm4i';
export const MTG_MAP_ZOOM = 15;
export const MTG_MAP_HEIGHT_LIST = 220;
export const MTG_MAP_HEIGHT_SINGLE = 200;
export const MTG_MAP_WIDTH = 1200;
export const MTG_MAP_LAT_DEFAULT = '-37.81838';
export const MTG_MAP_LONG_DEFAULT = '144.95731';
export const MTG_MAP_ADDRESS_DEFAULT =
    'Boardtrac, L23, 40 City Road, HWT Tower, Southbank VIC 3006, Australia';
export const MTG_VIEW_SINGLE = 0;
export const MTG_VIEW_LIST = 1;

export const MTG_PENDING = -1;
export const MTG_DECLINED = 0;
export const MTG_ATTENDING = 1;
export const MTG_TENTATIVE = 2;
export const MTG_PENDING_TXT = 'Not yet responded';
export const MTG_DECLINED_TXT = 'Not attending';
export const MTG_ATTENDING_TXT = 'Attending';
export const MTG_TENTATIVE_TXT = 'Tentatively attending';

// Governance
export const GOV_DEFAULT_TITLE = 'Governance';

export const REQUEST_GOVERNANCE = 'REQUEST_GOVERNANCE';
export const ASK_DELETE_ALL_ANNOTATIONS = 'Are you sure you want to delete all your annotations?';

// Members
export const MEMBERS_DEFAULT_TITLE = 'Members';

// Votes
export const VOTE_DRAFT = 1;
export const VOTE_OPEN = 2;
export const VOTE_CLOSED = 3;
export const VOTE_MAJORITY = 0;
export const VOTE_UNANIMOUS = 1;
export const VOTE_PENDING = -1;
export const VOTE_ABSTAIN = 0;
export const VOTE_YES = 1;
export const VOTE_NO = 2;

export const PERM_VOTE_READ = 1; //View the vote
export const PERM_VOTE_NOTES = 2; //Add notes/hightlights to document
export const PERM_VOTE_PRINT = 4; //Print vote document
export const PERM_VOTE_EMAIL = 8; //Email vote document
export const PERM_VOTE_VOTE = 16; //Allowed to vote
export const PERM_VOTE_VIEW_OTHERS = 32; //View other's votes
export const PERM_VOTE_VIEW_OUTCOME = 64; //View the voting counts

export const isVoteNew = vote => {
    return (
        (vote.VotePermissions & PERM_VOTE_VOTE) === PERM_VOTE_VOTE &&
        vote.CurrentCastVote === VOTE_PENDING
    );
};

export const VOTE_VIEW_SINGLE = 0;
export const VOTE_VIEW_LIST = 1;

// WorthARead

// this is the size of the icon
export const SIZE = 25;

// this is icon of the comment
export const D =
    'M499.968 214.336q-113.832 0 -212.877 38.781t-157.356 104.625 -58.311 142.29q0 62.496 39.897 119.133t112.437 97.929l48.546 27.9 -15.066 53.568q-13.392 50.778 -39.06 95.976 84.816 -35.154 153.45 -95.418l23.994 -21.204 31.806 3.348q38.502 4.464 72.54 4.464 113.832 0 212.877 -38.781t157.356 -104.625 58.311 -142.29 -58.311 -142.29 -157.356 -104.625 -212.877 -38.781z';

export const HIGHLIGHT_TOOL = 'highlight';
export const POINT_TOOL = 'point';

export const DOC_TYPE_GOVERNANCE = 2;
export const DOC_TYPE_AGENDA = 6;
export const DOC_TYPE_VOTE = 3;
export const DOC_TYPE_WAR = 5;

export const PDF_CONTENT_TYPE = 'application/pdf';

export const DOC_CONTENT_TYPE = 'application/msword';
export const DOCX_CONTENT_TYPE =
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export const XLS_CONTENT_TYPE = 'application/vnd.ms-excel';
export const XLSX_CONTENT_TYPE =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const PNG_CONTENT_TYPE = 'image/png';
export const JPEG_CONTENT_TYPE = 'image/jpeg';
export const BMP_CONTENT_TYPE = 'image/bmp';
export const WEBP_CONTENT_TYPE = 'image/webp';
export const GIF_CONTENT_TYPE = 'image/gif';

export const HTML_DOC_TYPE = 'html';

export const WRONG_EXTENSIONS_MSG = 'This document type is not supported:';

export const PDF_TYPE = 'pdf';

export const TIMEOUT = 1200000; //20 mins
export const TIMEOUT_DELAY = 30000; //30 secs
export const TIMEOUT_PLACEHOLDER = '-PLACEHOLDER-';

export const PASSWORD_TOKEN_GONE = 'gone';
export const APP_TYPE_WEB_APP = 'webapp';
export const APP_TYPE_ELECTRON_APP = 'electron';

// export const JPG_TYPE = 'jpg';
// export const JPEG_TYPE = 'jpeg';
// export const PNG_TYPE = 'png';
// export const BMP_TYPE = 'bmp';
// export const WEBP_TYPE = 'webp';
// export const GIF_TYPE = 'gif';

// PIN Pages
export const PIN_PROCEDURE_CREATE = 'CREATE';
export const PIN_PROCEDURE_CONFIRM = 'CONFIRM';
export const PIN_PROCEDURE_UNLOCK = 'UNLOCK';
export const OFFLINE_ACCESS_TOKEN = 'OFFLINE_ACCESS_TOKEN';

// TASK Pages
export const TASK_ALL = 0;
export const TASK_MINE = 1;

export const TASK_NOT_COMMENCED     = 0;
export const TASK_NOT_COMMENCED_TXT = 'Not commenced';
export const TASK_IN_PROGRESS      = 2;
export const TASK_IN_PROGRESS_TXT  = 'In progress';
export const TASK_COMPLETE          = 4;
export const TASK_COMPLETE_TXT      = 'Complete';
export const TASK_ARCHIVED          = 6;
export const TASK_ARCHIVED_TXT      = 'Archived';

export const TITLE         = "Title";
export const CATEGORY_NAME = "CategoryName";
export const DUE_DATE_TIME = "DueDateTime";
export const ASSIGNEE_NAME = "AssigneeName";
export const STATUS        = "Status";
export const LIST_GROUP_VOTES = 'LIST_GROUP_VOTES';
export const LIST_GROUP_TASKS = 'LIST_GROUP_TASKS';


// WEBPACK FOOTER //
// ./src/helpers/constants.js